import { Button, generalUtils } from '@shared/common';

import { useCheckout } from '~/hooks/use-checkout';
import { useAppLead } from '~/hooks/useAppLead';
import { useProducts } from '~/hooks/useProducts';
import { useTracking } from '~/hooks/useTracking';

export const familyPlanRoute = 'checkout-family-plan';
export const familyPlansIds = ['154', '155', '156'];

// Note: mapping default products to products with increased +7$ price
const productToFamilyPlanMap: Record<string, string> = {
  142: '154',
  143: '155',
  144: '156',
};

export const familyPlanToProductMap: Record<string, string> = {
  154: '142',
  155: '143',
  156: '144',
};

export const FamilyPlanUpgradeBox = () => {
  const { selectedPlan, updateUser } = useAppLead();
  const { findProductById } = useProducts();
  const { currency } = useCheckout();
  const { plansSelect } = useTracking();
  const planId = selectedPlan?.id || '142';
  const familyPlanId = productToFamilyPlanMap[planId];

  const handleAddFamilyPlan = () => {
    if (!familyPlanId) {
      console.error(`No family plan mapping found for plan ID: ${planId}`);
      return;
    }

    const product = findProductById(familyPlanId);

    if (product) {
      updateUser({ selectedPlan: product });
      plansSelect({
        category: product.key,
        label: product.title,
      });
    } else {
      console.error(`Family plan product not found for ID: ${familyPlanId}`);
    }
  };

  return (
    <>
      {familyPlanId ? (
        <div className='bg-white border border-gray-200 rounded-lg px-4 py-6 mb-6 w-full'>
          <div className='flex justify-between items-center gap-4 pb-4'>
            <h3 className='text-xl font-bold text-dark leading-tight'>Upgrade to family plan</h3>
            <div className='flex items-end flex-col mr-2'>
              <span className='text-red-500 text-sm line-through' aria-label='Original price'>
                {generalUtils.formatPrice(49, currency)}
              </span>
              <span className='text-3xl font-bold leading-none text-dark' aria-label='Discounted price'>
                {generalUtils.formatPrice(7, currency)}
              </span>
            </div>
          </div>
          <div className='flex justify-center items-center gap-8 pb-4'>
            <div className='flex flex-col gap-1'>
              <p className='text-sm text-dark'>
                Achieving your goals is much easier and fun when you have supportive people around you.
              </p>
              <p className='font-bold text-dark text-sm'>
                If you add this upgrade to your order, you will be eligible to create 2 more accounts for your family
                members for free.
              </p>
            </div>
          </div>
          <div className='flex justify-between text-xs border-t border-gray-200 py-2 mb-4 font-bold gap-1 text-green-800 leading-tight'>
            <span>One-time purchase</span>
            <span>24,500+ people took this offer</span>
            <span>2 seats available</span>
          </div>
          <Button className='w-full' onClick={handleAddFamilyPlan} aria-label='Add family plan upgrade to order'>
            + Add this to my order
          </Button>
        </div>
      ) : null}
    </>
  );
};
